import { Block, BlockGrid, Boundary, SectionGrid } from '../types';
import { locateBlockInGrid } from './locate-block-in-grid';

export function filterMoveBlockBoundaries(
  boundaries: Boundary[],
  sectionGrids: SectionGrid[],
  blockId: Block['id']
): Boundary[] {
  const result = locateBlockInGrid(sectionGrids, blockId);
  if (!result) {
    return boundaries;
  }
  const { sectionIndex, rowIndex, colIndex, isFirstInRow, isLastInRow, isOnlyBlockInRow } = result;

  return boundaries.filter((boundary) => {
    if (boundary.sectionIndex !== sectionIndex) {
      return true;
    }
    if (boundary.orientation === 'horizontal') {
      if (!isOnlyBlockInRow) {
        return true;
      }
      if (boundary.insertionRow === rowIndex) {
        return !isFirstInRow;
      }
      if (boundary.insertionRow === rowIndex + 1) {
        return !isLastInRow;
      }
      return true;
    }
    if (boundary.orientation === 'vertical') {
      if (rowIndex === boundary.insertionRow) {
        return boundary.insertionCol !== colIndex && boundary.insertionCol !== colIndex + 1;
      }
      return true;
    }
    return true;
  });
}
